import React from 'react';
import { Upload, Icon, Modal ,Button} from 'antd';
import ReactDOM from'react-dom';
import AsyncAppHOCFN from "../AsyncAppHOC";
import IntlWrap from "../intlWrap";

class Export extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount(){
  }
  upload=(e)=>{
      const {getDate,locale,onChange} = this.props;
      let params=new FormData();
      let oAbc=this.el;
      for (let i = 0; i < oAbc.files.length; i++) {
          console.log(oAbc.files[i]);
          let file=oAbc.files[i];
          params.append('files',file,file.name);
      }
      getDate(
          {
              name:'getExportDate',
              url:'http://192.168.3.80:10207/api/107102118',
              params:params,
              options:{
                  method: 'post',
                  headers: {
                      Accept: 'application/json',
                      'Accept-Language': locale || 'zh-CN',
                      accessToken: localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : '',
                  }},
              locale
          },()=>{
              let {getExportDate}=this.props;
              console.log(getExportDate,'getExportDate');
              let rows=getExportDate.posts&&getExportDate.posts.productVos||[];
              if(onChange&&typeof onChange=="function"){
                  onChange(rows)
              }
          })
  }
  importPurchasingOrde=()=>{
    let {multiple}=this.props;
      this.el = document.createElement('input');
      this.el.type="file";
      if(multiple){
          this.el.multiple='multiple'
      }
      this.el.addEventListener('change',this.upload);
      this.el.click()
  };
  componentWillUnmount(){
      this.el=null
  }
  render(){
    let {style}=this.props;
    return <div>
      <Button  style={{...style}} onClick={this.importPurchasingOrde}>导入</Button>
    </div>

  }
}
export default IntlWrap(AsyncAppHOCFN(Export));